import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import commonEn from "../locales/en/common.json";
import commonNL from "../locales/nl/common.json";
import navigationEN from "../locales/en/navigation.json";
import navigationNL from "../locales/nl/navigation.json";
import reportEN from "../locales/en/report.json";
import reportNL from "../locales/nl/report.json";
import productEN from "../locales/en/product.json";
import productNL from "../locales/nl/product.json";
import settingsNL from "../locales/nl/settings.json";
import settingsEN from "../locales/en/settings.json";
import functionsEN from "../locales/en/functions.json";
import functionsNL from "../locales/nl/functions.json";
import bookingEN from "../locales/en/booking.json";
import bookingNL from "../locales/nl/booking.json";

export const defaultNS = "common";

export const defaultLanguage = "en";

export const resources = {
  en: {
    common: commonEn,
    navigation: navigationEN,
    report: reportEN,
    product: productEN,
    settings: settingsEN,
    functions: functionsEN,
    booking: bookingEN,
  },
  nl: {
    common: commonNL,
    navigation: navigationNL,
    report: reportNL,
    product: productNL,
    settings: settingsNL,
    functions: functionsNL,
    booking: bookingNL,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: defaultLanguage,
    fallbackLng: defaultLanguage,
    debug: false,
    defaultNS,
    resources,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })
  .catch((e) => {
    console.error(e);
  });

export default i18n;
